import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import validator from 'validator';

import actions from '../../../store/actions';
import SimpleForm from '../../SimpleForm';

import 'react-image-crop/dist/ReactCrop.css';

import './index.scss';

const FooterIcons = ({ expanded }) => {
  if (expanded) {
    return null;
  }
  return (
    <ul className="chat-box__footer__icons">
      <li>
        <img src="/assets/images/chat-box/icon-attachment.svg" alt="Anexo" />
      </li>
    </ul>
  );
};

class ChatFooter extends SimpleForm {
  constructor(props) {
    super(props);

    this.state = {
      message: '',
      disabled: true,
      src: null,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    // this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event) {
    const message = event.target.value;
    const disabled = validator.isEmpty(message, { ignore_whitespace: true });

    this.setState({
      message,
      disabled,
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();

    const { message } = this.state;

    this.setState({ message: '' });

    const { sendMessage } = this.props;
    sendMessage(message, 'TEXT');
  };

  asyncStringify = async (obj) => {
    return JSON.stringify(obj);
  };

  handleClickAccessClick = () => {
    this.props.handleToggleQuickAccess();
  };

  handleClickOutside = (event) => {
    const quickAccessButton = document.getElementById('quick-access-button');
    const quickAccessContainer = document.getElementById(
      'quick-access-container-list'
    );
    if (
      !quickAccessContainer?.contains(event.target) &&
      !quickAccessButton?.contains(event.target)
    ) {
      this.props.handleQuickAccessClose();
    }
  };

  componentDidMount() {
    document.addEventListener('mousedown', (event) =>
      this.handleClickOutside(event)
    );
  }

  componentWillUnmount() {
    document.addEventListener('mousedown', (event) =>
      this.handleClickOutside(event)
    );
  }

  onSelectFile = async (e) => {
    const { sendMessage } = this.props;
    e.persist();
    if (e.target.files && e.target.files.length > 0) {
      const extSplit = e.target.files[0].name.split('.');
      const file = e.target.files[0];
      const ext = extSplit[extSplit.length - 1].toLowerCase();
      document.getElementById('profile_pic').value = null;
      const reader = new FileReader();
      await reader.readAsDataURL(file);
      const properties = {
        name: file.name,
        ext,
        size: file.size,
      };
      if (
        ext === 'jpeg' ||
        ext === 'png' ||
        ext === 'jpg' ||
        ext === 'gif' ||
        ext === 'bmp'
      ) {
        await reader.addEventListener(
          'load',
          () => sendMessage(reader.result, 'IMAGE', ext),
          false
        );
      } else if (
        ext === 'mp3' ||
        ext === 'wav' ||
        ext === 'ogg' ||
        ext === 'oga' ||
        ext === 'mpga'
      ) {
        await reader.addEventListener(
          'load',
          () => sendMessage(reader.result, 'AUDIO', ext),
          false
        );
      } else if (ext === 'mp4' || ext === 'm4v') {
        await reader.addEventListener(
          'load',
          () => sendMessage(reader.result, 'VIDEO', ext),
          false
        );
      } else if (
        ext === 'doc' ||
        ext === 'docx' ||
        ext === 'txt' ||
        ext === 'csv' ||
        ext === 'pdf' ||
        ext === 'xls' ||
        ext === 'xlsx' ||
        ext === 'ppt' ||
        ext === 'pptx'
      ) {
        await reader.addEventListener(
          'load',
          async () => {
            sendMessage(reader.result, 'DOCUMENT', ext, properties);
          },
          false
        );
      } else if (
        ext === 'zip' ||
        ext === 'rar' ||
        ext === 'gz' ||
        ext === '7z'
      ) {
        await reader.addEventListener(
          'load',
          () => {
            sendMessage(reader.result, 'DOCUMENT', ext, properties);
          },
          false
        );
      }
    }
  };

  render() {
    const { message, disabled } = this.state;

    return (
      <footer className="chat-box__footer">
        <div />

        <form
          onSubmit={this.handleSubmit}
          className={`form-chat-box-footer align-self-center ${
            this.props.isQuickAccessActive ? '' : 'deactivate'
          }`}
        >
          <div className="chat-box__footer__input">
            <label className="custom-file-upload">
              <input
                type="file"
                className="form-control-file"
                id="profile_pic"
                onChange={this.onSelectFile}
                style={{ display: 'none', cursor: 'pointer' }}
              />
              <FooterIcons />
            </label>

            <label
              id="quick-access-button"
              className={`quick-access-icon ${
                this.props.isQuickAccessOpen ? '' : 'disable'
              } 
                ${this.props.isQuickAccessActive ? '' : 'deactivate'}`}
              onClick={this.handleClickAccessClick}
            >
              <img
                src="/assets/images/chat-box/duvidas_frequentes.svg"
                alt="Acesso Rápido"
              />
            </label>

            <input
              type="text"
              placeholder="Digite sua mensagem"
              autoComplete="off"
              maxLength={1000}
              name="message"
              value={message}
              onChange={this.handleInputChange}
            />
            <button
              type="button"
              className="chat-box__footer__submit"
              disabled={disabled}
              onClick={this.handleSubmit}
            >
              <img src="/assets/images/chat-box/icon-send.svg" alt="Enviar" />
            </button>
          </div>
        </form>
      </footer>
    );
  }
}

const mapStateToProps = (state) => ({
  message: state.previewBot.currentMessage,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(actions.previewBot, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ChatFooter);
